/**
 * @file pc 样式的checkbox， migration from swap
 * @author liudy
 */

import React, { ChangeEvent, Component, MouseEvent } from 'react';

import './checkbox.scss';

export interface ICheckboxProps {
    isChecked: boolean;          // 是否选中
    iSStopPropagation?: boolean; // 是否禁用点击冒泡事件
    tooltipTitle?: string;
    onChange?: (isChecked: boolean) => void;               // 选中后的回调，用于向外派发数据
    disabledCheck?: boolean;       // 不允许选中
    disabled?: boolean;
    isDeepIcon?: boolean;
}

export interface ICheckboxState {
    isChecked: boolean;          // 是否选中
}


export default class Checkbox extends Component<ICheckboxProps, ICheckboxState> {
    constructor(props: ICheckboxProps) {
        super(props);
        this.state = {
            isChecked: props.isChecked,
        };
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    public UNSAFE_componentWillReceiveProps(newProps: ICheckboxProps) {
        if (newProps.isChecked !== this.props.isChecked) {
            this.setState({
                isChecked: newProps.isChecked,
            });
        }
    }
    public onClick(event: MouseEvent<HTMLDivElement>) {
        if (this.props.iSStopPropagation) {
            event.stopPropagation();
        }
    }
    public onChange(event: ChangeEvent<HTMLInputElement>) {
        if (!event.target) {
            return;
        }
        const checked = event.target.checked;
        if (this.props.disabledCheck && checked) {
            if (this.props.onChange) {
                this.props.onChange(false);
            }
            return;
        }

        this.setState({
            isChecked: checked,
        });

        if (this.props.onChange) {
            this.props.onChange(checked);
        }
    }

    public render() {
        return (
            <div className={`m-checkbox
                ${this.state.isChecked ? 'checked' : ''}
                ${this.props.disabledCheck ? 'disabled-check' : ''}
            `} onClick={this.onClick}  tooltip-title={this.props.tooltipTitle || ''}>
                <input type="checkbox" checked={this.state.isChecked}
                onChange={this.onChange} disabled={this.props.disabled}/>
                <i className={`icon icon-checkbox  ${this.props.isDeepIcon ? 'deep' : ''}`}></i>
            </div>
        );
    }
}




